import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import MultiStepActivationContainer from './Components/MultiStepActivationContainer';
import { useTranslation, Trans } from 'react-i18next';
import { themeColor } from '../Theming';
import { useNavigate } from 'react-router-dom';
import { Path } from '../Routing';
import { hasSliideOrigin } from '.';
import {
  MultiStepHeaderText,
  addSliideText,
} from './PartnerPluginActivateMultiStep';
import colors from '../Theming/colors';
import { useQuery } from '../Common/Hooks';
import clsx from 'clsx';

const SubTitleTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SubTitleText = styled.div`
  color: ${themeColor('darkestGrey')};
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  width: 310px;
`;

const LinkText = styled.a`
  color: ${themeColor('blue')};
`;

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

const BodyContentContainer = styled.div`
  width: 320px;
  min-height: 106px;
  margin-top: 33px;
  margin-left: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MultiStepStyledButton = styled.button`
  flex-shrink: 0;
  color: ${themeColor('white')};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background-color: ${colors.successGreen};
  width: 260px;
  height: 40px;
  border-radius: 5px;

  &.sliide {
    background-color: ${colors.verizonRed};
    width: 308px;
    height: 40px;
    border-radius: 20px;
    margin-top: 10px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  }
`;

const MultiStepStyledTransparentButton = styled.button`
  font-size: 13px;
  font-weight: 400;
  margin-top: 33px;
  color: ${colors.lightGrey};
  background-color: transparent;
  flex-shrink: 0;
  font-style: normal;
  line-height: normal;

  &.sliide {
    font-size: 14px;
    font-weight: 700;
    margin-top: 25px;
    color: ${colors.verizonGrey};
  }
`;

const PartnerPluginActivateMultiStepAlmostThere = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const navigate = useNavigate();
  const [sliide] = useState(hasSliideOrigin());

  const handleUpdateNow = () => {
    navigate({
      pathname: Path.PluginActivationUpdatePermissions,
      search: location.search,
    });
  };

  const openApp = useCallback(() => {
    const origin = query.get('origin');
    if (origin) window.location.href = `${origin}://`;
  }, [query]);

  return (
    <MultiStepActivationContainer
      headerTextWidth={240}
      headerTextColor="white"
      backgroundColor="#323A68"
      headerText={'PartnerpluginsdkActivate.multiStep.almostThere'}
      headerTextTopPadding={40}
      sliide={sliide}
    >
      <MultiStepHeaderText sliide={sliide}>
        {t('PartnerpluginsdkActivate.multiStep.alwaysAllow')}
      </MultiStepHeaderText>
      <SubTitleTextContainer>
        <SubTitleText>
          <Trans
            t={t}
            i18nKey="PartnerpluginsdkActivate.multiStep.needToAlways"
          >
            <LinkText>AbsoluteText</LinkText>
          </Trans>
        </SubTitleText>
      </SubTitleTextContainer>
      <BodyContentContainer>
        <MultiStepStyledButton
          className={clsx({ sliide })}
          onClick={handleUpdateNow}
        >
          {t('PartnerpluginsdkActivate.multiStep.updateNow')}
        </MultiStepStyledButton>
        <MultiStepStyledTransparentButton
          className={clsx({ sliide })}
          onClick={openApp}
        >
          {t(
            'PartnerpluginsdkActivate.multiStep.iWillDoItLater' +
              addSliideText(sliide)
          )}
        </MultiStepStyledTransparentButton>
      </BodyContentContainer>
    </MultiStepActivationContainer>
  );
};

export default PartnerPluginActivateMultiStepAlmostThere;
